import { useState } from "react";
import { Menu, X } from "lucide-react";
import { Button } from "@/components/ui/button";

const JOTFORM_URL = "https://pci.jotform.com/form/260353574059056";

const navLinks = [
  { name: "Home", href: "#home" },
  { name: "Meet Masky", href: "#meet-masky" },
  { name: "Passport", href: "#passport" },
  { name: "How It Works", href: "#how-it-works" },
  { name: "Gallery", href: "#gallery" },
  { name: "Grading", href: "#grading" },
  { name: "Timetable", href: "#timetable" },
  { name: "Pricing", href: "#pricing" },
  { name: "FAQs", href: "#faqs" },
  { name: "Contact", href: "#contact" },
];

export default function Navbar({ isScrolled, topOffset }) {
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);

  const scrollToSection = (e, href) => {
    e.preventDefault();
    const element = document.querySelector(href);
    if (element) {
      element.scrollIntoView({ behavior: "smooth" });
    }
    setMobileMenuOpen(false);
  };

  return (
    <nav
      data-testid="navbar"
      className={`fixed left-0 right-0 z-50 transition-all duration-300 ${topOffset || "top-0"} ${
        isScrolled
          ? "bg-[#0A1A2F] shadow-lg py-2"
          : "bg-[#0A1A2F] py-4"
      }`}
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex items-center justify-between">
          {/* Logo */}
          <a
            href="#home"
            onClick={(e) => scrollToSection(e, "#home")}
            className="flex items-center gap-3"
            data-testid="nav-logo"
          >
            <img
              src="https://customer-assets.emergentagent.com/job_1abea0ec-cded-4678-a29f-de28c813ea65/artifacts/32qtaxsv_Design.png"
              alt="Masky - Fighting Fit Fencing Mascot"
              className="h-10 w-10 object-contain masky-glow-sm"
            />
            <span className="text-white font-bold text-lg hidden sm:block font-['Montserrat']">
              Fighting Fit Fencing
            </span>
          </a>

          {/* Desktop Navigation */}
          <div className="hidden lg:flex items-center gap-4">
            {navLinks.slice(0, 6).map((link) => (
              <a
                key={link.name}
                href={link.href}
                onClick={(e) => scrollToSection(e, link.href)}
                className="text-white/90 hover:text-[#D4A857] transition-colors text-sm font-medium font-['Montserrat']"
                data-testid={`nav-link-${link.name.toLowerCase().replace(" ", "-")}`}
              >
                {link.name}
              </a>
            ))}
            <Button
              onClick={() => window.open(JOTFORM_URL, "_blank")}
              className="bg-[#D4A857] hover:bg-[#C49A4D] text-[#0A1A2F] font-bold px-6 py-2 rounded font-['Montserrat'] uppercase tracking-wide text-sm"
              data-testid="nav-cta-button"
            >
              Get Your Pass
            </Button>
          </div>

          {/* Mobile Menu Button */}
          <button
            className="lg:hidden text-white p-2"
            onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
            data-testid="mobile-menu-button"
          >
            {mobileMenuOpen ? <X size={28} /> : <Menu size={28} />}
          </button>
        </div>

        {/* Mobile Menu */}
        {mobileMenuOpen && (
          <div
            className="lg:hidden absolute top-full left-0 right-0 bg-[#0A1A2F] shadow-lg py-4 animate-slide-up"
            data-testid="mobile-menu"
          >
            {navLinks.map((link) => (
              <a
                key={link.name}
                href={link.href}
                onClick={(e) => scrollToSection(e, link.href)}
                className="block px-4 py-3 text-white hover:bg-[#0D2240] transition-colors font-medium font-['Montserrat']"
              >
                {link.name}
              </a>
            ))}
            <div className="px-4 pt-3">
              <Button
                onClick={() => window.open(JOTFORM_URL, "_blank")}
                className="w-full bg-[#D4A857] hover:bg-[#C49A4D] text-[#0A1A2F] font-bold py-3 rounded font-['Montserrat'] uppercase"
              >
                Get Your Pass
              </Button>
            </div>
          </div>
        )}
      </div>
    </nav>
  );
}
